import { useEffect, useRef, useState } from "react";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { GetRefrenceWithTransactionId, NewReferencesOfAccount } from "../../../../../Utils/AllPagesQuriesAndMutations";
import { Confirm } from "../../../Confirmation/Confirm";
import Input from "../../../Input/Input";
import { AmountDetails, TransactionTypeDetails, initialRef } from "../../ReferenceSection/Reference.config";
import { ReferenceModal } from "../../ReferenceSection/ReferenceModal";
import { TransactionInput } from "./TransactionInput";
import { IsoToDateWithoutTime } from "../../../../../CommonFunction/IsoDateTime";
import { VscReferences } from "react-icons/vsc";
const { useLazyQuery } = require("@apollo/client");

function JournalVoucherTableRow({
  formik,
  i,
  handleRowDelete,
  onTransactionChange,
  el,
  tablerow,
  loadingState,
  Form_Key,
  TypeOfPortal,
  setFirstLoad = () => { }
}) {
  const [EntryType, SetEntryType] = useState("");
  const rowRef = useRef(null);
  const [GetReference] = useLazyQuery(GetRefrenceWithTransactionId, {
    fetchPolicy: "network-only",
  });
  const [RefIcon, setRefIcon] = useState(false);
  const [toggle, settoggle] = useState(false);
  const [deleteState, setDeleteState] = useState(false);
  const [modalToggle, setModalToggle] = useState(false);
  const [id, setID] = useState();
  const [RefRows, setRefRows] = useState({});

  const [handleRefChange, setHandleRefChange] = useState(() => (ele) => { });
  const dispatch = useDispatch();

  const ChangeDeleteState = (id) => {
    if (tablerow.length > 2) {
      setID(id);
      settoggle(true);
      setDeleteState(true);
    }
  };

  // useEffect(() => {
  //   if (EntryType === "Debit" || el.Transaction_Type === "Debit") {
  //     setDr(el.Amount);
  //     setCr("");
  //   }
  //   if (EntryType === "Credit" || el.Transaction_Type === "Credit") {
  //     setCr(el.Amount);
  //     setDr("");
  //   }
  // }, [EntryType, el]);

  const handleInputChange = (e) => {
    onTransactionChange(e, "Amount", el.id);
  };
  const MasterData = useSelector((store) => store?.FormDataReducer);
  // const MasterData = useSelector((store) => store.FormFieldData.masterData);
  useEffect(() => {
    setTimeout(() => {
      const newHandleRefChange = (elmt) => { };
      setHandleRefChange(() => newHandleRefChange);
    }, 3000);
  }, [MasterData]);

  const handleInputBlur = (element) => {
    let Name = element?.name;

    const AccountInfo = MasterData?.MasterData?.[Form_Key]?.[Name];
    if ((AccountInfo?.Balance_Method === "Bill By Bill" || AccountInfo?.Balance_Method === true)) {
      setModalToggle(true);
    }
  };
  useEffect(() => {
    console.log(el)
    let Name = el?.name;
    const AccountInfo = MasterData?.MasterData?.[Form_Key]?.[Name]?.Balance_Method;
    console.log(TypeOfPortal == "Edit" && typeof el.id === "string" && (AccountInfo?.includes("Bill By Bill") || AccountInfo === true), "$$$$", TypeOfPortal, typeof el.id === "string", AccountInfo)
    if (TypeOfPortal == "Edit" && typeof el.id === "string" && (AccountInfo?.includes("Bill By Bill") || AccountInfo === true)) {
      GetReference({
        variables: {
          TransactionId: el.id,
        },
      })
        .then((res) => {
          let updatedTransRef = {};
          console.log(res?.data);
          res?.data?.getRefrenceWithTransactionId?.map((el) => {
            let InitialRef = [
              ...initialRef.slice(0, -1),
              AmountDetails,
              TransactionTypeDetails,
              initialRef[initialRef.length - 1],
            ];
            let singleRef = InitialRef.map((item) => {
              if (item.name === "Particular") {
                item = { ...item, NewRef_Id: el["NewRef_Id"] };
              }
              if (item.name === "RefDate") {
                console.log(IsoToDateWithoutTime(el[item.name]), el);
                return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
              }
              return { ...item, value: el[item.name] };
            });
            updatedTransRef = {
              ...updatedTransRef,
              [Math.random() * 10]: singleRef,
            };
          });
          setRefRows({
            [el.id]: updatedTransRef,
          });
          if (res?.data?.getRefrenceWithTransactionId?.length) {
            setRefIcon(true);
          }
        })
        .catch((err) => console.log(err.message, "error message"));
    }
  }, [el.id]);
  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);
  const page = MasterData?.MasterData[Form_Key];
  const Account_ID = page && page[el.name]?.Account_Balance_Id;
  console.log(el);
  return (
    <>
      <tr
        className="inputRows"
        ref={rowRef}
        key={i}
      // onBlur={(e) => handleInputBlur(e)}
      >
        <td>
          <div className="">
            <Input
              EMTQuery=""
              checked={""}
              InputConfig={el}
              name={`Transaction_Type`}
              value={el.Transaction_Type}
              label={``}
              type="inputdrop"
              modalform={true}
              Iconinside={true}
              handleInputChange={(e) => {
                SetEntryType(e.target.value);
                onTransactionChange(e, "Transaction_Type", el.id);
                setFirstLoad(curr => {
                  return curr || true;
                });
              }}
              dropdowndata={["Credit", "Debit"]}
              handleBlur={formik.handleBlur}
              touched={formik.touched["Transaction_Type"]}
              error={formik.errors["Transaction_Type"]}
              max={Infinity}
              JurnalDropdown={true}
              PaymentProcess={true}
              formkey={Form_Key}
              notSearchable={true}
            />
          </div>
        </td>
        <td>
          <div className="">
            <Input
              EMTQuery=""
              checked={""}
              name={el.name}
              value={el[el.name]}
              label={``}
              type="InputDropForQuery"
              modalform={true}
              Iconinside={true}
              handleInputChange={(e) => {
                onTransactionChange(e, el.name, el.id);

                handleRefChange(el);
              }}
              handleBlur={formik.handleBlur}
              touched={formik.touched[el.name]}
              error={formik.errors[el.name]}
              JurnalDropdown={true}
              PaymentProcess={true}
              formkey={Form_Key}
              InputConfig={el}
            />
          </div>
        </td>
        <td>
          <TransactionInput
            value={EntryType === "Debit" || el.Transaction_Type === "Debit" ? el.Amount : ""}
            type="number"
            disabled={EntryType === "Debit" || el.Transaction_Type === "Debit" ? false : true}
            handleInputChange={handleInputChange}
            jvTransactions={true}
            onBlur={(e) => {
              handleInputBlur(el);
            }}
          />
        </td>
        <td>
          <TransactionInput
            value={EntryType === "Credit" || el.Transaction_Type === "Credit" ? el.Amount : ""}
            type="number"
            disabled={EntryType === "Credit" || el.Transaction_Type === "Credit" ? false : true}
            handleInputChange={(e) => {
              onTransactionChange(e, "Amount", el.id);
              //formik.handleChange(e);
            }}
            jvTransactions={true}
            onBlur={(e) => {
              handleInputBlur(el);
            }}
          />
        </td>
        <td className="ReferenceIconForJV">
          {RefIcon && <VscReferences onClick={() => handleInputBlur(el)} />}
        </td>
        <td
          onClick={() => {
            ChangeDeleteState(el.id);
          }}
        >
          <MdDelete />
        </td>
      </tr>
      <>
        {deleteState ? (
          <Confirm
            toggle={toggle}
            settoggle={settoggle}
            submit={() => {
              handleRowDelete(id);
            }}
            loadingState={loadingState ? true : false}
          />
        ) : (
          ""
        )}
      </>
      <>
        {modalToggle ? (
          <ReferenceModal
            Amount={Number(el.Amount)}
            transactionId={el.id}
            setModalToggle={() => setModalToggle(false)}
            show={modalToggle}
            Account_ID={Account_ID}
            query={NewReferencesOfAccount}
            Transaction_Type={el.Transaction_Type}
          />
        ) : (
          ""
        )}
      </>
    </>
  );
}

export default JournalVoucherTableRow;
